module.exports = {
  pleaseWait:"Please wait",
  loading:"loading",
  ID:"ID",
  FAQ:"FAQ",
  TC:"T&C",
  Submit:"Submit",
  change:"Change",
  English:"English",
  Myanmar:"Myanmar",
  Login:"Login",
  Logout:"Log out",
  register:"Register",
  Confirm:"Confirm",
  OK:"OK",
  getCode:"Resend",
  Continue:"Continue",
  language0:"Language",
  language:"Choose Language",
  Copyright:"© 2025 All Rights Reserved.",
  Daily:"Daily",
  Weekly:"Weekly",
  ChancesLeft:"My Points",
  BuyChances:"Buy More Chances",
  BuyChancesC:"You're about to make a one-time purchase.",
  ConfirmPurchase:"Confirm Purchase",
  languageTips:"Choose your language here",
  loginTips:"Enter a phone number",
  profile:"Profile",
  phoneNumber:'Phone Number',
  select:"Select",
  Monthly:"Monthly",
  PhoneNo:"Phone No",
  Level:"Level",
  Rank:"Rank",
  RedeemCenter:"Redeem Center",
  redeemTips1:"browse available items",
  Categories:"Categories",
  ChooseHere:"Choose Here",
  game1T:"AI Training",
  game2T:"Ranked Mode",
  game2T2:"Rank Mode",
  game3T:"Team Mode",
  game4T:"Endless Challenge",
  game1C:"Your smart quiz partner! Improve your Skills!",
  game2C:"Challenge other players in real-time quizzes!",
  game3C:"Challenge your knowledge together with your friends!",
  Ranking:"Ranking",
  rankList:"Rank List",
  RedeemList:"Redeem List",
  Settings:"Settings",
  ChooseTitle:"Choose Your Favourite",
  Save:"Save",
  Back:"Back",
  game1Tips1:"Select difficulty levels",
  Easy:"Easy",
  Medium:"Medium",
  Hard:"Hard",
  Matchmaking:"Matchmaking",
  BackToHome:"Back To Home",
  PlayAgain:"Play Again!",
  WaitingTips:"Waiting for friends to join",
  Draw:"Same Score: Draw",
  GameOver:"Game Over",
  CreateRoom:"Create Room",
  JoinRoom:"Join Room",
  RoomID:"Room ID",
  enterRoomID:"Please Enter Room ID",
  MatchingLevel:"Matching range level",
  Waiting:"Waiting",
  Congratulations:"Congratulations !you won",
  SorryLost:"Sorry, you lost",
  YourScore:"Your score",
  OpponentScore:"Opponent's score",
  StartNow:"Start Now!",
  subscribe:'Subscribe',
  Later:'Later',
  BuyMore:'Buy More',
  Points:'Points',
  Chances:'Chances',
  ChanceEnough:'Your Chance is not enough',
  currentLevel:'Your current Level',
  YouCanRedeem:'You can redeem',
  moreTimes:'more times.',
  Redeem:'Redeem',
  congratulations:'CONGRATULATIONS',
  redeemTips:'You are about to redeem',
  Challenge:'Challenge',
  RankingChallenge:'Ranking Challenge',
  FriendChallenge:'Friend Challenge',
  FastChallenge:'Fast Challenge',
  nickname:'Nickname',
  PickLevel:'Pick a Level',
  PiggyBank:'Piggy Bank',
  PiggyBankTips1:'Your Piggy Bank is full!',
  PiggyBankTips12:'Your Piggy Bank is not full',
  CollectNOW:'Collect NOW',
  PiggyBankTips2:'The Piggy Bank fills up every 30mins with 50 shiny coins just for you! Don\'t let those coins go to waste—claim them now and boost your balance!',
  invitation:'Invite & Get Rewards!',
  invitationTips:'Copy your invite link and receive “1000 coins” when a friend joins and plays!',
  InviteFriends:'Invite Friends',
  copy:'Copy',
  DaysLogin:'7-Days Login',
  SpinWheel:'Spin Wheel',
  books:'Books',
  Cancel:'Cancel',
  Upgrade:'Upgrade',
  bookTips1:'Upgade City BooK!',
  Costs:'Costs',
  bookTips2:'Unable to upgrade, insufficient knowledge books or point',
  BackgroundMusic:'Background Music',
  spin:'Spin!',
  luckySpin:'Lucky Spin',
  spinTips1:'You’ve Won a',
  tks:'Thank You!',
  spinTips2:'Daily Free Spin!',
  spinTips3:'Claim your FREE Lucky Spin Token and try your luck today!',
  spinTips4:'Get My Token',
  SpinChances:'Spin Chances',
  date:'Date',
  Prizes:'Prizes',
  nochance:'You don\'t have enough chance',
  WinnerList:'Winner List',
  Purchasefailed:'Purchase failed',
  start:'Start',
  No:'No',
  Title:'Title',
  RequireLevel:'Require Level',
  Bouns:'Bouns',
  YourRoomCode:'Your Room Code',
  shop:'Shop',
  Shop:'Shop',
  bank:'Bank',
  home:'Home',
  enterRoomCode:'Enter a Room Code',
  getChance:'get Spin Wheel Chance',
  landTips1:'Your fortune Awaits!',
  landTips2:'Answer fun questions to earn coins and spin the Fortune Wheel! Each spin gives you a chance to win exciting prizes!',
  reture:'Return',
  question_ready:'Preparing questions',
  question:'Question',
  Correct:'Correct',
  Category:'Category',
  Claim:'Claim',
  Game_Time:'Game Time',
  Game_Bonus:'Game Bonus',
  Game_Free:'Game Free',
  Rewards:'Rewards',
  EntryFee:'EntryFee',
  Spins:'Spins',
  book_rule:'Book Upgrade Rule',
  Book_in_Need:'Book in Need',
  Coin_in_Need:'Coin in Need',
  Coin_Bonus:'Coin Bonus',
  daily_challenge:'Daily Challenge : ',
  share_challenge:'Share Challenge : ',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js